const defaultLocale = "de";
const locales = [defaultLocale, "en"];

module.exports = { locales, defaultLocale };
